<template>
  <div
    class="mask"
    :style="mobileMaskAndModal || (PCMaskAndModal && PCMaskAndModal.mask)"
    v-if="showDialogModal"
  >
    <div class="PDFDownload-modal">
      <slot name="PDFDownload"></slot>
    </div>
    <div
      class="message-modal"
      :style="mobileMaskAndModal || (PCMaskAndModal && PCMaskAndModal.msgModal)"
    >
      <div class="head" v-if="showCancelBtn" @click="hide">
        <img src="~img/cancel.png" alt="cancel" />
      </div>
      <div>
        <slot name="content"></slot>
      </div>
      <div>
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DialogModal',
    props: {
      showDialogModal: {
        type: Boolean,
        default: false,
      },
      options: {
        type: Object,
        default: () => {},
      },
      showCancelBtn: {
        type: Boolean,
        default: true,
      },
      mobileMaskAndModal: {
        type: Object,
        default: () => {},
      },
      PCMaskAndModal: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {};
    },

    methods: {
      show() {
        this.$emit('show', true);
      },

      hide() {
        this.$emit('show', false);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile';
</style>
